import React, { useState } from "react";
import useFacility from "../../../utils/hooks/useFacility";
import { REMOVE_WEB_USER } from "../../api/apiRoutes";
import { post } from "../../api";
import { setSuccessMessage } from "../../store/alerts/alertsActions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../../features/ModalComponent";
import { logOut } from "../../store/auth/authActions";
import EAButton from "../shared/Buttons/EAButton";

const RemoveWebUser: React.FC = () => {
  const facilityIds = useFacility();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const onClickRemoveWebUser = () => {
    setOpenConfirmation(true);
  };

  const onRemoveWebUser = async () => {
    const { isError } = await post(REMOVE_WEB_USER(facilityIds));
    if (!isError) {
      dispatch(logOut());
      dispatch(setSuccessMessage("Usunięto konto użytkownika"));
    }
  };

  const handleCloseConfirmation = () => {
    setOpenConfirmation(false);
  };
  return (
    <>
      <EAButton title={t("usun_konto")} onClick={() => onClickRemoveWebUser()} fullWidth variant="text" />
      {openConfirmation && (
        <ModalComponent
          open
          footer={true}
          closeModal={handleCloseConfirmation}
          title={t("czy_na_pewno_chcesz_usnac_swoj_konto")}
          onAccept={onRemoveWebUser}
        >
          <></>
        </ModalComponent>
      )}
    </>
  );
};

export default RemoveWebUser;
